import { render, staticRenderFns } from "./HelpLinks.vue?vue&type=template&id=446e8ec1&scoped=true&"
import script from "./HelpLinks.vue?vue&type=script&lang=ts&"
export * from "./HelpLinks.vue?vue&type=script&lang=ts&"
import style0 from "./HelpLinks.vue?vue&type=style&index=0&id=446e8ec1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e8ec1",
  null
  
)

export default component.exports